export const ChatInputKeyAction = Object.freeze({
  NONE: "none",
  SEND: "send",
  INSERT_NEWLINE: "insert_newline",
  CLOSE_CHAT: "close_chat",
});

const hasChatText = (chatText) =>
  typeof chatText === "string" && chatText.trim().length > 0;

export const getChatInputKeyAction = ({
  key,
  shiftKey = false,
  isRecording = false,
  chatText = "",
} = {}) => {
  if (key === "Enter") {
    return shiftKey
      ? ChatInputKeyAction.INSERT_NEWLINE
      : ChatInputKeyAction.SEND;
  }

  if (key === "Escape" && !isRecording && !hasChatText(chatText)) {
    return ChatInputKeyAction.CLOSE_CHAT;
  }

  return ChatInputKeyAction.NONE;
};

export default getChatInputKeyAction;
